import Alert from '@storeblocks/alert';
import { type FC } from 'react';

import { Holdings } from '@/api/fundHoldings/models/Holdings';
import { Fund } from '@/api/funds/models';
import { useTexts } from '@/hooks/useTexts';

import { FundListAccordion } from './FundListAccordion';

interface Props {
  allFunds: Fund[];
  holdings: Holdings;
  isHoldingsQueryError: boolean;
}

/**
 * List of all the funds the customer has holdings in.
 */
export const FundsWithHoldings: FC<Props> = ({
  allFunds,
  holdings,
  isHoldingsQueryError,
}) => {
  const texts = useTexts();

  if (isHoldingsQueryError) {
    // Display an error message to make it more obvious to it is this
    // component that is failing.
    return (
      <>
        <h2>{texts.pages.fundList.fundsInYourPortfolio.title}</h2>

        <Alert
          description={texts.genericError}
          variant="error"
          data-test="fund-list-my-funds-error"
        />
      </>
    );
  }

  const holdingIsins = holdings.all.map((holding) => holding.isin);

  const myFunds = allFunds.filter((fund) => holdingIsins.includes(fund.isin));

  if (myFunds.length === 0) {
    // The customer has no holdings in any Connect funds.
    // Thus, there is nothing to display.
    return null;
  }

  return (
    <>
      <h2>{texts.pages.fundList.fundsInYourPortfolio.title}</h2>

      <FundListAccordion
        funds={myFunds}
        data-test="fund-list-my-funds"
        hasHoldingsInFunds
      />
    </>
  );
};
